import * as types from './constants'
import apiService, { setAxiosHeader } from '../../apiService/apiService'
import { toPlanProfile, toUserProfile } from '../../mapper/planMapper'
import { toast } from 'react-toastify'

export const registerUser = (
    password,
    firstName,
    lastName,
    mobile,
    history
) => {
    const data = {
        Password: password,
        Mobile: mobile,
        FirstName: firstName,
        LastName: lastName,
    }
    return (dispatch) => {
        dispatch({
            type: types.REGISTERATION_START,
        })
        apiService.auth
            .register(data)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.REGISTERATION_SUCCESS,
                        isRegistrationDone: true,
                    })
                } else {
                    dispatch({
                        type: types.REGISTERATION_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                if (error?.response?.status == '403') {
                    dispatch({
                        type: types.REGISTERATION_DUPLICATE,
                        payload: error.response.data,
                    })
                    history.push('/signin')
                    return
                }

                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.REGISTERATION_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const validateUser = (mobile, validationKey, history) => {
    const data = {
        userName: mobile,
        token: validationKey,
    }
    return (dispatch) => {
        dispatch({
            type: types.VALIDATION_START,
        })
        apiService.auth
            .validateUser(data)
            .then((response) => {
                if (response.status == 200) {
                    const { token } = response.data
                    localStorage.setItem('token', token)
                    setAxiosHeader(token)
                    dispatch({
                        type: types.VALIDATION_SUCCESS,
                        payload: token,
                    })
                    window.location.href = '/app'
                } else {
                    dispatch({
                        type: types.VALIDATION_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.VALIDATION_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const getProfile = () => {
    return (dispatch) => {
        dispatch({
            type: types.VALIDATION_START,
        })
        apiService.profile
            .get()
            .then(async (response) => {
                if (response.status == 200) {
                    const profile = response.data
                    const { data: imageUrl } =
                        await apiService.profile.getProfilePicture()
                    return dispatch({
                        type: types.GET_PROFILE_SUCCESS,
                        payload: { ...toUserProfile(profile), image: imageUrl },
                    })
                } else {
                    dispatch({
                        type: types.GET_PROFILE_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_PROFILE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const uploadProfile = (file) => {
    return (dispatch) => {
        dispatch({
            type: types.UPLOAD_PROFILE_START,
        })

        apiService.profile
            .uploadProfile(file)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.UPLOAD_PROFILE_SUCCESS,
                    })
                    toast.success('عکس پروفایل شما با موفقیت آپلود شد')

                    return dispatch(getProfile())
                } else {
                    dispatch({
                        type: types.UPLOAD_PROFILE_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                toast.error(
                    'مشکلی در آپلود عکس پروفایل بوجود آمد، لطفا دوباره تلاش کنید'
                )

                dispatch({
                    type: types.UPLOAD_PROFILE_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const changeName = (firstName, lastName) => {
    return (dispatch) => {
        dispatch({
            type: types.CHANGE_NAME_START,
        })

        apiService.profile
            .changeName(firstName, lastName)
            .then((response) => {
                dispatch({
                    type: types.CHANGE_NAME_SUCCESS,
                })
                toast.success('نام با موفقیت تغییر یافت')
                return dispatch(getProfile())
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                toast.error('تغییر نام با مشکل مواجه شد، لطفا دوباره تلاش کنید')
                dispatch({
                    type: types.CHANGE_NAME_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const uploadPlan = (dataUrl) => {
    return (dispatch, getState) => {
        const fabricIds =
            getState().tools.roomInDesignStage?.selectedPrespectives?.map(
                (q) => q.material.id
            )
        const roomId = getState().tools.roomInDesignStage?.id

        dispatch({
            type: types.UPLOAD_PLAN_START,
        })

        if (!fabricIds || fabricIds.length === 0) {
            return dispatch({
                type: types.UPLOAD_PLAN_FAIL,
                error: null,
            })
        }

        apiService.profile
            .uploadPlan(dataUrl, roomId, fabricIds)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.UPLOAD_PLAN_SUCCESS,
                    })
                    return dispatch(getProfile())
                } else {
                    dispatch({
                        type: types.UPLOAD_PLAN_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.UPLOAD_PLAN_FAIL,
                    error: errorMessage,
                })
            })
    }
}
